/* eslint-disable @stylistic/indent */
export const deepCopy = function (obj) {
    try {
        const ret = JSON.parse(JSON.stringify(obj))
        return ret
    } catch {
        return {}
    }
}

export const zeroPadding = function (NUM, LEN) {
    return (Array(LEN).join('0') + NUM).slice(-LEN)
}

export const isNumber = function (val) {
    try {
        if (typeof val === 'number') {
            return Number.isFinite(val)
        }

        if (typeof val === 'string') {
            const trimmedVal = val.trim()
            if (trimmedVal === '') {
                return false
            }

            return /^[-+]?(?:\d+\.\d+|\d+|\.\d+)$/.test(trimmedVal)
        }
        return false
    } catch (e) {
        console.error('isNumber error', e)
        return false
    }
}

export const nocache = function (_second) {
    try {
        const second = isNaN(_second) ? 600 : _second
        const now = new Date()
        return Math.floor(now.getTime() / (1000 * second))
    } catch (e) {
        console.error('nocache error', e)
        return -1
    }
}

export const addSignNumString = function (num) {
    if (isNaN(num)) {
        return ''
    } else {
        if (num == 0) {
            return String('±' + num)
        } else if (num > 0) {
            return String('+' + num)
        } else {
            return String(num)
        }
    }
}

export const errorJSONStringify = function (_obj) {
    if (typeof (_obj) === 'object') {
        const errorObj = {
            name: _obj?.name,
            message: _obj?.message,
            stack: _obj?.stack
        }
        const errorString = JSON.stringify(errorObj)
        return errorString
    }
    if (typeof (_obj) === 'string') {
        return _obj
    } else {
        return '{message:\'errorObj is not an object\'}'
    }
}
